import React from 'react'
import SvgCheck from '#/assets/images/icons/check_circle.svg'
import Tooltip from '#/components/Tooltip'
import plans, { roleOrders } from '#/consts/plan'
import cn from '#/utils/classnames'
import styles from '../styles.module.scss'
import { FeatureProps } from '../types'

const roles: TopHap.UserRole[] = ['basic', 'pro', 'expert', 'enterprise']

export function Feature({ title, tooltip, role, skipBasic = false }: FeatureProps) {
  let allowedRoles = roles
  if (skipBasic) { allowedRoles = ['pro', 'expert', 'enterprise'] }
  return (
    <div className={styles['th-feature']}>
      <div className={styles['th-title']}>
        {title}
        {tooltip && (
          <Tooltip tooltip={tooltip} trigger='hover'>
            <div className={styles['th-feature-tooltip']}>ⓘ</div>
          </Tooltip>
        )}
      </div>
      {allowedRoles.map(e => (
        <div key={e} className={styles['th-plan-feature']}>
          {roleOrders[e] >= roleOrders[role] ? (
            <SvgCheck
              className={styles['th-check-icon']}
              style={{ color: plans.monthly[e].color }}
            />
          ) : null}
        </div>
      ))}
    </div>
  )
}

export function FeaturesHeader({
  title,
  skipBasic = false
}: { title: string, skipBasic?: boolean }) {
  let allowedRoles = roles
  if (skipBasic) { allowedRoles = ['pro', 'expert', 'enterprise'] }
  return (
    <div className={cn(styles['th-feature'], styles['th-feature-header'])}>
      <div className={styles['th-title']}>{title}</div>
      {allowedRoles.map(e => (
        <div key={e} className={styles['th-plan-feature']} />
      ))}
    </div>
  )
}
